import { render } from "./About.vue?vue&type=template&id=f3908ef6&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=f3908ef6&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3908ef6"]])

export default __exports__